import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as jobTitles from '../../job-titles'

export const RESOURCE = {
  payload: {
    description: "A designation defining an employee's role.",
    dimension: jobTitles.RESOURCE.payload,
    level: 0,
    name: 'Job Title',
    partialId: PartialId.Standard.create('job_title'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
